<template>
  <div>
    <div class="Button-antecedentes">
      <b-button class="btn-antecedentes" variant="link">
        <i class="bx bx-download" style="color:#052333"></i>
        <a href="/datos/Prioridades Ley de Presupuesto 2020.zip">
        Prioridades de la Ley de Presupuesto año 2020
        </a>
      </b-button>

      <b-button class="btn-antecedentes" variant="link">
        <i class="bx bx-download" style="color:#052333"></i>
        <a href="/datos/Formato BGI 2020_rev.docx">
        Formato BGI 2020
        </a>
      </b-button>
      
      
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
};
</script>

<style scoped>
.bx-download {
  margin-right: 10px;
  font-size: 20px;
}

.btn-antecedentes {
  text-align: left;
}

.Button-antecedentes {
  display: grid;
  justify-content: left;
}
</style>
